import {getUserObject, assortments} from "utils/relewise";

function getPopularProducts(options) {
  return {
    Settings: {
      NumberOfRecommendations: 10,
      AllowFillIfNecessaryToReachNumberOfRecommendations: true,
      AllowReplacingOfRecentlyShownRecommendations: true,
      RecommendVariant: true,
      prioritizeDiversityBetweenRequests: false,
      SelectedProductProperties: {
        DisplayName: true,
        Pricing: true,
      },
      SelectedVariantProperties: {
        DisplayName: true,
        Pricing: true,
        DataKeys: [
          "COM_ShopifyHandle",
          "DE_ShopifyHandle",
          "DK_ShopifyHandle",
          "SE_ShopifyHandle",
          "UK_ShopifyHandle",
          "NO_ShopifyHandle",
          "ImageUrls",
        ],
      },
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    Currency: {
      Value: window.mosmosh.currency.iso,
    },
    Filters: {
      Items: [
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "ProductAssortmentFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "VariantAssortmentFilter",
        },
      ],
    },
    DisplayedAtLocationType: "Personal Product Recommendations",
  };
}

export default getPopularProducts
